import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import RankingListComponent from '../components/rankingList/rankingList.jsx';
import {closeRankingListModal, openStudentinfoModal} from "../redux/actions/modelsActive";
import {getClassTongjiRequest} from "../service/user";
import HomeComponent from "../components/home/home";
import defaultImg from "../img/bee.png";
import {FILE_URL} from "../util/constants";
import PubSub from "pubsub-js";

class RankingListContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'getClassTongjiList',
            'chakanInfo',
            'handleImageErrored'
        ]);
        this.state = {
            studentList:[]
        }

        PubSub.subscribe('faceCollectSuccess', (event, data) => {
            console.log('有新人脸采集');
            this.getClassTongjiList();
        });

    }

    componentDidMount() {

        this.getClassTongjiList();
    }



    handleImageErrored(index){

        var list = this.state.studentList;
        list[index].img = defaultImg;

        this.setState({
            studentList:list,
        });
    }

    chakanInfo(pid,name,face_imgurl){
        sessionStorage.setItem('studentpid',pid)
        sessionStorage.setItem('studentname',name)

        sessionStorage.setItem('face_imgurl',face_imgurl)

        this.props.openStudentinfoModal();
    }

    getClassTongjiList(){
        getClassTongjiRequest(sessionStorage.getItem('classcode'),'1', (data) => {
            console.log(data)
            if(data.ret=='1'){
                // this.setState({
                //     studentList:data.data.xuesheng
                // });

                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img==null||list[i].img==''?'':list[i].img
                }

                this.setState({
                    studentList:list
                });
            }else{
                this.setState({
                    studentList:[]
                });
            }
        });
    }

    render() {

        return (
            <RankingListComponent
                closeRankingListModal={this.props.closeRankingListModal}
                studentList={this.state.studentList}
                chakanInfo={this.chakanInfo}
                handleImageErrored={this.handleImageErrored}
            />
        )
    }


}

RankingListContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeRankingListModal: () => dispatch(closeRankingListModal()),
        openStudentinfoModal:() => dispatch(openStudentinfoModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RankingListContainer);
